export default {
      id: "check-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "sprite.svg#check-usage",
      toString: function () {
        return this.url;
      }
    }